import { QueryHandlingService, WatchQueryRef } from '@akebono/core';
import { ChangeDetectionStrategy, Component, Input, OnInit } from '@angular/core';
import { Observable } from 'rxjs';
import { map } from 'rxjs/operators';

import {
  CurrentLotMarksListsGQL,
  CurrentLotMarksListsQuery,
  CurrentLotMarksListsQueryVariables,
} from '../../graphql/service/graphql-auto-main-service';

@Component({
  selector: 'app-lot-shared-includes',
  templateUrl: './lot-shared-includes.component.html',
  styleUrls: ['./lot-shared-includes.component.scss'],
  changeDetection: ChangeDetectionStrategy.OnPush,
})
export class LotSharedIncludesComponent implements OnInit {
  @Input() lotId!: number;

  queryRef!: WatchQueryRef<CurrentLotMarksListsQuery, CurrentLotMarksListsQueryVariables>;
  loading$!: Observable<boolean>;
  data$!: Observable<string[]>;

  constructor(
    private readonly qhs: QueryHandlingService,
    private readonly currentLotMarksListsGQL: CurrentLotMarksListsGQL,
  ) {}

  trackByValue = (_: number, v: string) => v;

  ngOnInit(): void {
    this.queryRef = this.qhs.watch(this.currentLotMarksListsGQL, {});
    this.loading$ = this.queryRef.loading;

    this.data$ = this.queryRef.data.pipe(
      map((res) => {
        const lists = res?.currentUser?.lotMarksLists ?? [];

        const titles = lists.flatMap((list) =>
          (list?.lotMarks ?? [])
            .filter((m) => m?.lot?.id === this.lotId)
            .map((m) => m?.userLotMarksListTitle ?? ''),
        );
        const cleaned = titles.map((s) => (s ?? '').trim()).filter((s) => s.length > 0);

        return Array.from(new Set(cleaned));
      }),
    );
  }
}
